export enum typesOfId {
  InterviewId = "InterviewId",
  Id = "Id",
  JobId = "JobId"
} 